import { Injectable } from '@angular/core';
import { Events } from '../models/events'
import { CommonapiService } from './commonapi.service';

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  public objevents: Events[] = new Array();

  constructor(
    private commonApiService: CommonapiService
  ) { }

  async getEvents() {
    this.objevents = new Array();
    const _obj = {
      Mode: "SEARCH",
      EventId: "0",
      EventName: "",
      SortBy: "EventDate",      
      Sort: "ASC",
      PageNumber: 1,
      NoOfRecordsPerPage: 100,
      DisplayFilter: 'Active',
      PropertyName: "EventDate",
      SortingBy: true,
    };

    let _dt = await this.commonApiService.postData("api/MarketingApi/DBEventsList/", _obj).toPromise();

    if (_dt && _dt[0] && _dt[0].dataSet && _dt[0].dataSet.mlEventsList && _dt[0].dataSet.mlEventsList.length > 0) {
      const _data = _dt[0].dataSet.mlEventsList;

      console.log(_data);

      _data.forEach(element => {
        this.objevents.push({
          id: element.eventId,
          eventname: element.eventName,
          date: element.eventDate,
          time: element.eventTime,
          venue: element.eventVenue,
          link: element.eventLink,
          isentryfull:element.isEntryFull
        });
      });
    }

    return this.objevents;
  }
}
